module.exports = __webpack_public_path__ + "img/sales.2cb96792.png";